import { StyledFoother } from "./styled"


export const Foother = () => {

    return(
        <StyledFoother>
            <h2>copyright ₢ 2022 - Todos os direitos reservados a Search API</h2>
        </StyledFoother>
    ) 
}